import { useDispatch, useSelector } from "react-redux";
import { AnyAction, Dispatch } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { Model } from "../Model";
import type { AppDispatch } from "./store";

export const useAppDispatch = (): ThunkDispatch<Model, null, AnyAction> & ThunkDispatch<Model, undefined, AnyAction> & Dispatch<AnyAction> => useDispatch<AppDispatch>();
export const useAppState = (): Model => useSelector<Model, Model>( m => m );

